import Api from "../ApiUtility/Api";


class ReferralDS {
  constructor() {
    this.api = new Api();
  }

  RM_INSERT(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referral_Insert')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  RM_Referrals_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referrals_By_MailID_Get')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  RM_Referral_Update(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referral_Update')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

  RM_Referrals_Notes_Insert(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referrals_Notes_Insert')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  RM_Referral_Status_Update(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referral_Status_Update')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  RM_Referral_By_ReferralID_Get(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referral_By_ReferralID_Get')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  RM_Referral_Info_To_Zoho_SEND(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referral_Info_To_Zoho_SEND')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  RM_Referral_To_Zoho_if_Exists_LINK(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referral_To_Zoho_if_Exists_LINK')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  RM_Referral_To_Zoho_LINK(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referral_Info_To_Zoho_Without_Checking_SEND')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }

}

export default ReferralDS;